import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../http";
import { CreateFertilizerPayload } from "../../../products/types";
import { getApiErrorMessage, toApiError } from "../utils";
import { createFormData } from "../helpers/createFormdata";

export const useUpdateFertilizer = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({ id, data }: { id: string; data: CreateFertilizerPayload }) => {
            try {
                const formData = createFormData(data);
                return (await api.put(`/products/fertilizer/update/${id}`, formData)).data;
            } catch (error) {
                throw toApiError(error, 'Erro ao atualizar fertilizante');
            }
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: ['fertilizers'] });
            queryClient.invalidateQueries({ queryKey: ['fertilizer', variables.id] });
        },
        onError: error => console.error('Erro ao atualizar fertilizante:', getApiErrorMessage(error, 'Erro ao atualizar fertilizante'))
    });
};
